import { IUser } from '@/@data'

// Returns initials from string
export const getInitials = (string: string) =>
  string.split(/\s/).reduce((response, word) => (response += word.slice(0, 1)), '')

export const getFullName = (user?: IUser) => `${user?.first_name || ''} ${user?.last_name || ''}`
